import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from 'interfaces/paginate-duck';
import { CarrierAreaContact } from 'interfaces/carrier-area-contact';

const { Types, Creators } = createActions(
  {
    request: ['query'],
    success: ['data', 'pagination'],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'PAGINATE_CARRIER_AREA_CONTACTS' }
);

export interface PaginateCarrierAreaContactsState extends IState {
  data: CarrierAreaContact[] | Record<string, any>[];
}

const INITIAL_STATE: PaginateCarrierAreaContactsState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateCarrierAreaContactsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: PaginateCarrierAreaContactsState,
  action: ISuccessAction
) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (
  state: PaginateCarrierAreaContactsState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateCarrierAreaContacts = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateCarrierAreaContactsTypes = Types;
export const PaginateCarrierAreaContactsActions = Creators;
